"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var settingsActions = require("@caddigital/sok-reducers/lib/actions/bid/reliablePartnerSettings");
var sok_ui_1 = require("@caddigital/sok-ui");
var utils_1 = require("views/ManagementView/utils");
var react_router_dom_1 = require("react-router-dom");
var ListContainer_1 = require("views/ManagementView/ListContainer");
exports.ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, items = data.items, selectedLanguage = data.selectedLanguage;
    var row = items[index];
    var setSelectedCustomer = (0, react_1.useContext)(ListContainer_1.ModalContext).setSelectedCustomer;
    var dispatch = (0, react_redux_1.useDispatch)();
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" }),
        React.createElement("div", { className: 'row__column dynamic mobile __name' },
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/management/").concat(row.id) }, row.name)),
        React.createElement("div", { className: "row__column" }, (0, utils_1.getColumn)('projects', row.projects)),
        React.createElement("div", { className: "row__column" }, (0, utils_1.getColumn)('employees', row.employees)),
        React.createElement("div", { className: "row__column" }, (0, utils_1.getColumn)('federated', (0, translation_1.getLocalization)(row.federated ? 'global/yes' : 'global/no'))),
        React.createElement("div", { className: "row__column" }, (0, utils_1.getColumn)('reliablePartnerCompanyName', row.reliablePartnerCompanyName || '-')),
        React.createElement("div", { className: "row__column" },
            React.createElement(sok_ui_1.Icon, { onClick: function () {
                    dispatch(settingsActions.toggleModal()),
                        setSelectedCustomer({
                            reliablePartnerCompanyName: row.reliablePartnerCompanyName,
                            uuid: row.uuid
                        });
                }, className: "fa-cog fa-fw" }))));
});
